export default function () {
	const debug = false;
	const contentElement = document.querySelector('#content');
	const sections = contentElement.querySelectorAll('section');
	const styleElement = document.createElement('style');
	const cssSpecificity = 'main#content ';

	styleElement.id = 'block-custom-spacing';
	document.head.appendChild(styleElement);

	let rules = ''; // Combine all rules and manage media queries more granularly

	sections.forEach((section) => {
		const secondClass = section.classList[1];
		const sectionId = section.id;
		if (!secondClass || !sectionId) return;

		const combinedClassName = `${secondClass}#${sectionId}`;
		const formatPaddingValue = (value) => value > 0 ? `${value}px` : '0';

		const desktopPt = section.dataset.desktopPt ? `padding-top:${formatPaddingValue(parseInt(section.dataset.desktopPt))};` : '';
		const desktopPb = section.dataset.desktopPb ? `padding-bottom:${formatPaddingValue(parseInt(section.dataset.desktopPb))};` : '';
		const mobilePt = section.dataset.mobilePt ? `padding-top:${formatPaddingValue(parseInt(section.dataset.mobilePt))};` : '';
		const mobilePb = section.dataset.mobilePb ? `padding-bottom:${formatPaddingValue(parseInt(section.dataset.mobilePb))};` : '';

		let sectionRules = '';
		if (desktopPt || desktopPb) {
			sectionRules += `${cssSpecificity}.${combinedClassName}{${desktopPt}${desktopPb}}`;
		}

		if (mobilePt || mobilePb) {
			// Apply mobile-specific styles within a media query
			rules += `@media (max-width:960px){${cssSpecificity}.${combinedClassName}{${mobilePt}${mobilePb}}}`;
			// If mobile styles are present, wrap desktop styles in a desktop media query
			rules += `@media (min-width:960px){${sectionRules}}`;
		} else {
			// If no mobile styles are present, add desktop styles directly
			rules += sectionRules;
		}
	});

	styleElement.textContent = rules;
}
